import {
    Box,
    Card,
    CardContent,
    Container,
    Divider,
    Link,
    List,
    ListItem,
    ListItemText,
    Typography
} from "@mui/material";
import React, {useEffect} from "react";
import CommissionTimeline from "../components/Commissions/CommissionTimeline";
import Grid2 from '@mui/material/Unstable_Grid2'
import contactInfo from "../util/Links";

import './Commissions.css';
import {TextBanner} from "../components/Text/TextBanner";
import {PricingTable} from "../components/Commissions/PricingTable";
import {EqualGridItem} from "../components/Util/EqualGridItem";
import {BasicCard} from "../components/Util/BasicCard";
import {SimpleYTEmbed} from "../components/Commissions/SimpleYTEmbed";


export default function CommissionsPage() {


    const extra = "Final price may differ depending on style, complexity and length."

    useEffect(() => {
        document.title = 'Commissions - MiD//RA'

    })

    return <div className="CommissionsPage">
        <Box padding={2} justifyContent="center">
            <TextBanner>
                <Typography align="center" variant="h2"> Commissions </Typography>
            </TextBanner>
        </Box>

        <Container maxWidth="sm" className="subtitleBox" sx={{padding: 2}}>
            <Typography align="center" variant="subtitle1">
                Glad to work with you!
            </Typography>

            <Typography align="center" variant="body1">
                I'll first give you a short overview of the services I can provide.
                <br/>
                Then, I'll go a bit deeper on
                the workflow details and previous work.
            </Typography>


            <Typography align="center" variant="body2">
                <br/>
                Alternatively, feel free to DM me on&nbsp;
                <Link href={contactInfo.twitter.link}>{contactInfo.twitter.name}</Link>!
            </Typography>
        </Container>

        <Divider>Overview</Divider>
        <Grid2 container spacing={2} padding={4}>
            <EqualGridItem>
                <BasicCard>
                    <Typography variant="h5"> Pricing </Typography>
                    {<PricingTable/>}
                </BasicCard>
            </EqualGridItem>

            <EqualGridItem>
                <Card>
                    <CardContent>
                        <Typography variant="h5"> Previous work </Typography>
                        <Typography variant="subtitle2"> Make sure to check out my&nbsp;
                            <Link href={contactInfo.twitter.link}>{contactInfo.twitter.name}</Link> for more! (WIPs, tryouts)
                        </Typography>
                        {/*<IFramePlaylist/>*/}
                        <SimpleYTEmbed title="Originals" url="https://www.youtube-nocookie.com/embed/videoseries?list=PLIQJaOnMiVDgGXbzoC5RUDsHqHCOs09go" />
                        <SimpleYTEmbed title="Covers" url="https://www.youtube-nocookie.com/embed/videoseries?list=PLIQJaOnMiVDjLelrcSeW0s5mp4bxOjV3g" />
                    </CardContent>
                </Card>

            </EqualGridItem>

        </Grid2>
        <Divider>Workflow</Divider>
        <Grid2 container spacing={2} padding={4}>
            <EqualGridItem>
                <Card>
                    <CardContent>
                        <Typography variant="h5">
                            Workflow
                        </Typography>

                        <Typography variant="body1">
                            I'll start with thinking of general ideas that fit your plan.
                            We can talk about details in these days too.
                            <br/>
                            <br/>
                            I'll sketch some ideas that I can come up with, one of which will be
                            further developed in the upcoming weeks. This next phase includes
                            finalizing the instrumentation and mixing. Duration of this phase varies
                            a lot between projects.
                            <br/>
                            <br/>
                            Depending on the complexity of the track I might need less or more time.
                        </Typography>
                    </CardContent>
                </Card>
            </EqualGridItem>

            <EqualGridItem>
                <Card>
                    <CardContent>
                        <Typography variant="h5"> General timeline </Typography>
                        <CommissionTimeline/>
                    </CardContent>
                </Card>
            </EqualGridItem>
        </Grid2>

        <Divider></Divider>
        <Grid2 container spacing={2} padding={4}>
            <EqualGridItem>
                <Card>
                    <CardContent>
                        <Typography variant="h5">Guidelines</Typography>
                        <List>
                            {[
                                "Currently, payment is only possible via PayPal invoices.",
                                "Prices are listed in euros.",
                                "Final price might slightly differ due to complexity and length.",
                                "Commercial use of a commissioned BGM is allowed.",
                                "I am allowed to showcase my work on my own platforms. However, it can be arranged such that " +
                                "only a sample of a particular piece is showcased.",
                                "Make sure to credit me using my Twitter or YouTube :D"
                            ].map(text =>
                                <ListItem dense>
                                    <ListItemText>
                                        - {text}
                                    </ListItemText>
                                </ListItem>
                            )}
                        </List>
                    </CardContent>
                </Card>
            </EqualGridItem>
            <EqualGridItem>
                <Card>
                    <CardContent>
                        <Typography variant="h5">Availability</Typography>
                        <Typography variant="body1">I'll try my best to be available for commissions. However, since I am
                        currently in university, sometimes I have to put work on hold.
                            <br/>
                            Make sure to follow me on&nbsp;
                            <Link href={contactInfo.twitter.link}>{contactInfo.twitter.name}</Link>&nbsp;for updates.
                        </Typography>
                    </CardContent>
                </Card>
            </EqualGridItem>
        </Grid2>

    </div>
}
